import { Component, Input, ViewEncapsulation, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { BaseFormComponent } from './base-form.component';

/*
 * usage :
 * <ys-phone-input formControlName="mobile"></ys-phone-input>
 */

@Component({
    selector: 'ys-phone-input',
    templateUrl: './ys-phone-input.component.html',
    styleUrls: ['./ys-phone-input.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => YSPhoneInputComponent),
            multi: true,
        },
    ],
})
export class YSPhoneInputComponent extends BaseFormComponent<any> {
    @Input() cssClass: string = '';
    @Input() config: {
        customPlaceholder?: string | undefined
    } = {};
    @Input()
    set disabled(isDisabled: boolean) {
        setTimeout(() => {
            if (this._control) {
                const control = this._control.control;
                isDisabled ? control.disable() : control.enable();
            }
        });
    }
    SearchCountryField = SearchCountryField;
    CountryISO = CountryISO;
    PhoneNumberFormat = PhoneNumberFormat;
    preferredCountries: CountryISO[] = [
        CountryISO.UnitedKingdom,
        CountryISO.Ireland,
        CountryISO.Iceland,
        CountryISO.France,
        CountryISO.Germany,
        CountryISO.Netherlands,
        CountryISO.Spain,
        CountryISO.Italy,
        CountryISO.Portugal,
        CountryISO.Belgium,
        CountryISO.Poland,
        CountryISO.Lithuania,
        CountryISO.Estonia,
        CountryISO.Latvia,
        CountryISO.Sweden,
        CountryISO.Finland,
        CountryISO.Norway,
        CountryISO.Austria,
    ];
}
